module.exports = __webpack_public_path__ + "static/img/200.f641218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/200.png
// module id = fAmB
// module chunks = 2